"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const keautils_1 = require("keautils");
const title_1 = require("../title");
class FieldLabel extends React.PureComponent {
    render() {
        const propLabel = this.props.label;
        const label = propLabel;
        return (React.createElement(title_1.Title, { titulo: label, error: this.props.error, size: "span", line: false }));
    }
}
/**Un campo de una ventana con un label y un hijo de edición */
class FormField extends React.PureComponent {
    render() {
        const label = this.props.label && ((typeof this.props.label == "string") ? React.createElement("label", null, this.props.label) : this.props.label);
        return (label ?
            (React.createElement("div", { className: "form-group " },
                React.createElement(FieldLabel, Object.assign({}, this.props, { error: keautils_1.toObservable(this.props.error) })),
                this.props.children)) : (this.props.children || null));
    }
}
exports.FormField = FormField;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/fields/formField.js
// module id = 88
// module chunks = 0